import React from 'react';
import './About.css';
import cvPdf from '../assets/documents/CV.pdf';
import profileImg from '../assets/images/profile.jpg';

const About = () => {

  const handleDownloadCV = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = cvPdf;
    link.download = 'Umar_Zayyar_FullStack_Developer_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="section about" id="about">
      <div className="container">
        <div className="section-title">
          <h2>About Me</h2>
        </div>
        <div className="about-content">
          <div className="about-image">
            <div className="image-frame">
              <img src={profileImg} alt="Umar Zayyar Profile" className="about-profile-img" />
            </div>
          </div>
          <div className="about-text">
            <h3>Full-Stack Developer & UI/UX Enthusiast</h3>
            <p>
              I'm a passionate full-stack developer with expertise in creating
              modern, responsive web applications and mobile apps. I love turning complex
              problems into simple, beautiful designs.
            </p>
            <div className="about-details">
              <div className="detail-item">
                <strong>Name:</strong>
                <span>Umar Zayyar</span>
              </div>
              <div className="detail-item">
                <strong>Email:</strong>
                <span>umarzayyar62@gmail.com</span>
              </div>
              <div className="detail-item">
                <strong>Experience:</strong>
                <span>3+ Years</span>
              </div>
              <div className="detail-item">
                <strong>Location:</strong>
                <span>DC Colony, Gujranwala</span>
              </div>
            </div>
            <button
              className="btn btn-secondary"
              onClick={handleDownloadCV}
            >
              <i className="fas fa-download"></i>
              Download CV
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;